import { routeUrls } from 'root/src/shared/descriptions/routes/routeUrls'
import router from 'next/router'

export default item => () => router.push(routeUrls.addCampaign({
	dropId: item.id,
}))
